// web-rnw twin of ./shortcutLabel.ts: «Ctrl+C» becomes «⌘C» on a Mac, an iPad
// with a keyboard included. This package compiles without the DOM lib.
declare const navigator: { platform?: string } | undefined;

const MAC = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform ?? "");

export const shortcutLabel = (shortcut: string): string => (MAC ? shortcut.replace(/^Ctrl\+/, "\u2318") : shortcut);
